import React, { useState } from "react";

import { useNavigate } from "react-router-dom";

export default function Services() {
    const navigate = useNavigate();
    
  const galleryData = [
  {
    id: 1,
    images: ["/images/app/custombuild.jpg"],
    title: "Custom Build",
    description: "At Aspire Homes, we specialize in creating custom-built homes that reflect your unique lifestyle and personality.",
    onClick: () => navigate("/custom")
  },
  {
    id: 2,
    images: ["/images/app/currentprojects.jpg"],
    title: "Current Projects",
    description: "Table of enter details and lead to contact us and email us.",
    onClick: () => navigate("/gallery")
  },
  {
    id: 3,
    images: ["/images/app/knockdownrebuild.jpg"],
    title: "Knock Down Rebuild",
    description: "Transform Your Property with Professional Knockdown Rebuild Solutions. Is your current home no longer meeting your family's needs?",
    onClick: () => navigate("/custom")
  },
   {
    id: 4,
    images: ["/images/app/web-design.jpg"],
    title: "Home Designs",
    description: "it come in a variety of designs, ranging from contemporary developments with a wide range of architectural styles to historic row houses with homogeneous facades.",
    onClick: () => navigate("/home")
  }
];


  const [visibleIndex, setVisibleIndex] = useState(0); // start index for visible cards
  const visibleCount = 4;

  const [isOpen, setIsOpen] = useState(false);
  const [currentCardIndex, setCurrentCardIndex] = useState(0);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [touchStartX, setTouchStartX] = useState(0);

  const openModal = (cardIndex) => {
    setCurrentCardIndex(cardIndex);
    setCurrentImageIndex(0);
    setIsOpen(true);
  };

  const closeModal = () => setIsOpen(false);

  const prevImage = () => {
    const images = galleryData[currentCardIndex].images;
    setCurrentImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const nextImage = () => {
    const images = galleryData[currentCardIndex].images;
    setCurrentImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const handleTouchStart = (e) => setTouchStartX(e.touches[0].clientX);
  const handleTouchEnd = (e) => {
    const diff = touchStartX - e.changedTouches[0].clientX;
    if (diff > 50) nextImage();
    else if (diff < -50) prevImage();
  };

   const handleSeeMore= () => {
    navigate("/gallery"); // navigate to /gallery
  };

  return (
    <section className="gallery-section">
      <h1 className="gallery-heading">Our Service</h1>
      <div className="gallery-grid">
        {galleryData.slice(visibleIndex, visibleIndex + visibleCount).map((card, index) => (
          <div className="gallery-card" key={card.id}>
            <div className="card-image">
              <img src={card.images[0]} alt={card.title} />
            </div>
            <div className="card-content">
              <h2>{card.title}</h2>
              <p>{card.description}</p>
              <button className="contact-btn" onClick={card.onClick}>
                Learn More
              </button>
            </div>
          </div>
        ))}
      </div>
      
      {/* Modal */}
      {isOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            <button className="modal-close" onClick={closeModal}>
              &times;
            </button>
            <button className="modal-prev" onClick={prevImage}>
              &#10094;
            </button>
            <img
              src={galleryData[currentCardIndex].images[currentImageIndex]}
              alt={galleryData[currentCardIndex].title}
            />
            <button className="modal-next" onClick={nextImage}>
              &#10095;
            </button>
            <div className="modal-caption">
              <h2>{galleryData[currentCardIndex].title}</h2>
              <p>{galleryData[currentCardIndex].description}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}